<template>
  <div
    :class="{
      'messages__chat_list_item test-chat_list_item': true,
      'messages__chat_list_item--unread': chat.count_unread
    }"
  >
    <div class="messages__chat_list_item__image">
      <img :src="imageURL" alt="" aria-hidden="true" />
    </div>
    <div class="messages__chat_list_item__text">
      <div class="messages__chat_list_item__name_and_date">
        <div class="messages__chat_list_item__name" :title="name">
          {{ name }}
        </div>
        <div
          v-if="lastMessage"
          class="messages__chat_list_item__date"
          :aria-label="formatDayForChat(lastMessage.inserted_at, { speakable: true })"
        >
          {{ formatDayForChat(lastMessage.inserted_at) }}
        </div>
      </div>
      <div class="messages__chat_list_item__last_message_and_unread_message_count">
        <div v-if="chat.count_unread" class="messages__chat_list_item__unread_message_count">
          <span aria-hidden="true" :title="unreadMessagesLabel(chat.count_unread)">{{ chat.count_unread }}</span>
          <span class="sr_only">
            {{ unreadMessagesLabel(chat.count_unread) }}
          </span>
        </div>
        <div class="messages__chat_list_item__last_message">
          <p v-if="lastMessage">
            <span v-if="lastMessage.type === 'sent'" class="messages__chat_list_item__last_message__by_you">
              {{ i18n.$gettext('You') }}:
            </span>
            {{ lastMessage.body }}
          </p>
          <p v-else class="messages__chat_list_item__no_last_message">
            {{ i18n.$gettext('No messages yet. Say hi.') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMemberChatScope } from './route_helpers.js'
import { formatDayForChat, toTimestamp, trimText } from './utils.js'

export default {
  name: 'ChatListItem',
  props: {
    chat: {
      required: true,
      validator: function (chat) {
        const basicCheck =
          typeof chat === 'object' && typeof chat.count_unread === 'number' && typeof chat.partner === 'object'

        if (basicCheck && chat.messages.length > 0) {
          const lastIdx = chat.messages.length - 1

          return typeof chat.messages === 'object' && chat.messages[lastIdx].body && chat.messages[lastIdx].inserted_at
        } else {
          return basicCheck
        }
      }
    }
  },
  computed: {
    name() {
      if (isMemberChatScope(this.$route)) {
        return this.chat.partner.publication.title
      } else {
        if (this.chat.partner.member.last_name) {
          return `${this.chat.partner.member.first_name} ${this.chat.partner.member.last_name}`
        } else {
          return this.chat.partner.member.first_name
        }
      }
    },
    imageURL() {
      if (isMemberChatScope(this.$route)) {
        return this.chat.partner.publication.logo_url
      } else {
        return this.chat.partner.member.avatar_url
      }
    },
    lastMessage() {
      const lastIdx = this.chat.messages.length - 1
      if (this.chat.messages[lastIdx]) {
        // last message body is visually trimmed in CSS by overflow and text-overflow
        // but is also needs to be actually trimmed, for screen readers
        return { ...this.chat.messages[lastIdx], body: trimText(this.chat.messages[lastIdx].body, 120) }
      } else {
        return null
      }
    }
  },
  methods: {
    unreadMessagesLabel(n) {
      return this.i18n.$ngettext('%{count} unread message', '%{count} unread messages', n, { count: n })
    },
    formatDayForChat(datetime, opts) {
      return formatDayForChat(toTimestamp(datetime), { ...opts, todayAsHour: true })
    }
  }
}
</script>
